var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrafts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17%",
    y: "-16.6%",
    width: "134%",
    height: "133.1%",
    filterUnits: "objectBoundingBox",
    id: "dboixcf42b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-76.7%",
    y: "-44.7%",
    width: "253.3%",
    height: "189.5%",
    filterUnits: "objectBoundingBox",
    id: "5i5kizuehd"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-14.1%",
    y: "-57.3%",
    width: "132.9%",
    height: "214.6%",
    filterUnits: "objectBoundingBox",
    id: "6xsdeqwnwf"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-76.7%",
    y: "-44.7%",
    width: "253.3%",
    height: "189.5%",
    filterUnits: "objectBoundingBox",
    id: "5ofiex01jh"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.838 0c1.097.642 1.645 1.354 1.645 2.136v11.728c0 1.274.982 2.08 2.135 2.136H17.44c-1.06-.506-1.644-1.218-1.752-2.136v-11.6C15.689.755 14.545 0 13.424 0H1.838z",
    id: "ahnh401u9a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.728 0c.955 0 1.729.774 1.729 1.728v4.197H0V1.728C0 .774.774 0 1.728 0z",
    id: "40mltagvzc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.033 11.376h12.408c.955 0 1.728.774 1.728 1.728V16H7.084",
    id: "h4f6hqx44e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.483 16v-4.197a1.728 1.728 0 1 1 3.457 0V14.7",
    id: "x9rmqlqlrg"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.738 1.406)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#ahnh401u9a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#dboixcf42b)",
    xlinkHref: "#ahnh401u9a"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#ahnh401u9a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.738 1.406)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#40mltagvzc"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#5i5kizuehd)",
    xlinkHref: "#40mltagvzc"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#40mltagvzc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 .738 28.782)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#h4f6hqx44e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#6xsdeqwnwf)",
    xlinkHref: "#h4f6hqx44e"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#h4f6hqx44e"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "matrix(1 0 0 -1 .738 27.481)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#x9rmqlqlrg"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#5ofiex01jh)",
    xlinkHref: "#x9rmqlqlrg"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#x9rmqlqlrg"
  }))), /*#__PURE__*/React.createElement("path", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    d: "M6.896 7.343h6.988"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafts);
export default __webpack_public_path__ + "static/media/drafts.fc835b0b381a9e63fd082f2f2527cf0c.svg";
export { ForwardRef as ReactComponent };